import { PropsFilter } from "../../models/api/props-filter";
import { TransactionsApiService } from "../../services/transactions/transactions-api.service";
import { DocumentsApiService } from "../../services/documents";
import { DocumentsFilter } from "../../models/documents";

interface IPage {
  pageNumber: number;
  pageSize: number;
}

export const loadEntities = async (
  apiService: TransactionsApiService | DocumentsApiService,
  ids: string[],
  query: string,
  page: IPage,
  signal: AbortSignal,
  propsFilter?: DocumentsFilter
) => {
  const response = await apiService.loadItems(
    { createdByUsers: ids, ...(propsFilter ?? {}) } as PropsFilter,
    query,
    apiService.defaultSort,
    page,
    false,
    60,
    signal
  );

  return response;
};
